const SocialSharingButtonsPresets = {
  SocialSharingButtons: {
    slots: {
      icon: {
        attrs: {
          icon: "mdi-share-variant",
          color: "#726AF3",
          size: "24"
        }
      },
      availableNetworks: ["facebook", "linkedin", "telegram", "twitter", "viber", "whatsapp"]
    }
  }
};
export {
  SocialSharingButtonsPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU29jaWFsU2hhcmluZ0J1dHRvbnNQcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvU29jaWFsU2hhcmluZ0J1dHRvbnNQcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0U29jaWFsU2hhcmluZ0J1dHRvbnM6IHtcblx0XHRzbG90czoge1xuXHRcdFx0aWNvbjoge1xuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdGljb246IFwibWRpLXNoYXJlLXZhcmlhbnRcIixcblx0XHRcdFx0XHRjb2xvcjogXCIjNzI2QUYzXCIsXG5cdFx0XHRcdFx0c2l6ZTogXCIyNFwiXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0YXZhaWxhYmxlTmV0d29ya3M6IFsnZmFjZWJvb2snLCAnbGlua2VkaW4nLCAndGVsZWdyYW0nLCAndHdpdHRlcicsICd2aWJlcicsICd3aGF0c2FwcCddLFxuXHRcdH1cblx0fSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBZSw4QkFBQTtBQUFBLEVBQ2Qsc0JBQXNCO0FBQUEsSUFDckIsT0FBTztBQUFBLE1BQ04sTUFBTTtBQUFBLFFBQ0wsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFVBQ04sT0FBTztBQUFBLFVBQ1AsTUFBTTtBQUFBLFFBQ047QUFBQSxNQUNEO0FBQUEsTUFDRCxtQkFBbUIsQ0FBQyxZQUFZLFlBQVksWUFBWSxXQUFXLFNBQVMsVUFBVTtBQUFBLElBQ3pGO0FBQUEsRUFDRTtBQUNGOyJ9
